/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import AsyncSelect from "react-select/async";
import { searchContents } from "../../services/api/contents/contents.api";
import AsyncLoading from "../AsyncLoading/AsyncLoading";
import Option from "../AssociateFieldset/Option/Option";

const PRODUCT_TYPE_BY_ENTITY = {
  dramaturgies: "DramaturgyProduct",
  varieties: "VarietyProduct",
};

const PAGE_SIZE = 50;

const SelectOriginalProduct = ({
  handleChange,
  handleClear,
  placeholder = "Selecione",
  type,
  isClearable,
}) => {
  const initialStateProducts = { create: [], load: [] };

  const [stateProducts, setStateProducts] = useState(initialStateProducts);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageInfo, setPageInfo] = useState(null);
  const cancelSourceRef = useRef(null);

  useEffect(
    () => () => {
      if (cancelSourceRef.current) cancelSourceRef.current.cancel();
    },
    []
  );

  const getProductsBySearchTerm = (inputValue, callback, pgNumber) => {
    if (inputValue && inputValue.length > 0) {
      if (cancelSourceRef.current) cancelSourceRef.current.cancel();
      const source = axios.CancelToken.source();
      cancelSourceRef.current = source;

      searchContents(
        {
          Title: inputValue,
          Types: [PRODUCT_TYPE_BY_ENTITY[type]],
          PageSize: PAGE_SIZE,
          PageNumber: pgNumber,
        },
        { cancelToken: source.token }
      )
        .then((response) => {
          const mappedData = response.items.items.map((item) => ({
            ...item,
            value: item.productId,
            label: item.title,
          }));

          setStateProducts({
            ...stateProducts,
            load: mappedData,
          });
          callback(mappedData);
          setPageInfo({
            currentPage: response.items.pageIndex,
            totalPages: response.items.totalPages,
          });
        })
        .catch((error) => {
          if (!axios.isCancel(error)) callback([]);
        });
    }
  };

  const handleReset = () => {
    handleClear();
    setSearchTerm("");
    setStateProducts(initialStateProducts);
    setPageInfo(null);
  };

  const handleChangeSetOriginalProducts = (item) => {
    if (!item) return handleReset();

    handleChange(item);
    setStateProducts({ ...stateProducts, create: item || [] });
  };

  // TODO: funcionalidade não é executada, mas será mantida para futuras implementações
  useEffect(() => {
    const ReactSelect = document.querySelector(".reactSelect__menu-list");
    ReactSelect &&
      ReactSelect.addEventListener("scroll", () => {
        const mathScroll = ReactSelect.scrollHeight - ReactSelect.scrollTop;
        if (mathScroll < 500 && pageInfo?.totalPages > pageInfo?.currentPage) {
          getProductsBySearchTerm(
            searchTerm?.inputValue,
            searchTerm?.callback,
            ++pageInfo.currentPage
          );
        }
      });
  }, [stateProducts]);

  useEffect(() => {
    const searchDebounce = setTimeout(() => {
      getProductsBySearchTerm(searchTerm?.inputValue, searchTerm?.callback, 1);
    }, 1000);

    return () => clearTimeout(searchDebounce);
  }, [searchTerm]);

  return (
    <div className="SelectOriginalProduct">
      <AsyncSelect
        value={stateProducts.create}
        loadOptions={(inputValue, callback) =>
          setSearchTerm({ inputValue, callback })
        }
        onChange={handleChangeSetOriginalProducts}
        className="reactSelect"
        classNamePrefix="reactSelect"
        components={{
          LoadingIndicator: () => <AsyncLoading />,
          Option,
        }}
        noOptionsMessage={() => "Nenhum item encontrado"}
        loadingMessage={() => "Carregando..."}
        placeholder={placeholder}
        isClearable={isClearable}
        openMenuOnClick={false}
      />
    </div>
  );
};

export default SelectOriginalProduct;
